import React, { Component } from 'react';

import { Typography, Stack } from '@mui/material';
import { Box } from '@mui/system';
import Lottie from 'react-lottie';

import animationData from '../lotties/maintenance.json';

class Maintenance extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStopped: false,
      isPaused: false
    };
  }

  render() {
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: animationData,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
      }
    };

    return (
      <Stack alignItems="center" flexDirection="row" sx={{ m: 2 }}>
        <Box
          display="flex"
          sx={{ justifyContent: 'center', flexDirection: 'column', alignItems: 'center' }}>
          <Typography variant="h4" textAlign="center" sx={{ color: '#474ca0' }}>
            {'Website is Under Maintenance'}
          </Typography>

          <Typography variant="subtitle2" textAlign="center" sx={{ color: '#474ca0' }}>
            {'This Website is currently undergoing maintenance. We will be back shortly'}
          </Typography>
        </Box>
        <Box display="flex">
          <Lottie
            options={defaultOptions}
            speed={1}
            isStopped={this.state.isStopped}
            isPaused={this.state.isPaused}
          />
        </Box>
      </Stack>
    );
  }
}

export default Maintenance;
